import { ITrackingAction } from '../../../tracking/tracking.data';

export enum DepositRequestTabsEnum {
  percent = 'percent',
  fixed = 'fixed',
}

export interface IDepositRequestTab {
  key: string;
  value: DepositRequestTabsEnum;
  trackingAction: ITrackingAction;
}
